import { useNavigate } from "react-router-dom";
import { CheckCheck, Trash2 } from "lucide-react";
import { Card, Loader, PageHeader } from "@/components/ui-helpers";
import { NotificationFeed, NotificationFilters } from "@/components/NotificationFeed";
import { usePagedNotifications } from "@/hooks/usePagedNotifications";
import { openNotification } from "@/lib/notifications";

export default function Notifications() {
  const nav = useNavigate();
  const n = usePagedNotifications();
  if (!n.data) return <Loader />;
  const open = (x) => { n.markLocal(x); openNotification(x, nav); };
  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" subtitle={`${n.data.unread} unread`}>
        <div className="flex gap-2">
          <button data-testid="notifications-mark-all" onClick={n.markAll} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl border border-slate-200 text-sm font-semibold text-primary"><CheckCheck className="h-4 w-4" /> Mark all as read</button>
          <button data-testid="notifications-clear-read" onClick={n.clearRead} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600"><Trash2 className="h-4 w-4" /> Clear read</button>
        </div>
      </PageHeader>
      <Card className="overflow-hidden">
        <div className="p-4 border-b border-slate-100"><NotificationFilters filter={n.filter} setFilter={n.setFilter} counts={n.data.categories} testPrefix="notifications-page" /></div>
        <NotificationFeed items={n.data.items} onOpen={open} onToggleRead={n.toggleRead} onDismiss={n.dismiss} onAct={n.act} empty="No notifications match this filter." />
        {n.data.items.length < n.data.total && (
          <div className="p-4 border-t border-slate-100">
            <button data-testid="notifications-load-more" onClick={n.loadMore} disabled={n.busy} className="px-4 py-2 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600 disabled:opacity-60">{n.busy ? "Loading…" : `Load more (${n.data.total - n.data.items.length} left)`}</button>
          </div>
        )}
      </Card>
    </div>
  );
}
